import { inject, Injectable } from '@angular/core';
import Keycloak from '@inoventoryapps/keycloak-js';
import { LOCAL_STORAGE_KEYS } from '../../enums/local-storage.enum';
import { SnackbarService } from '../snackbar/snackbar.service';
import { StorageService } from '../storage/storage-service';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private readonly keycloak = inject(Keycloak);
    private readonly snack = inject(SnackbarService);
    private readonly storageService = inject(StorageService);

    getLoggedinUser() {
        return this.keycloak.token;
    }

    getUserGUID() {
        return this.keycloak.tokenParsed?.sub || '';
    }

    getAccessToken() {
        return this.keycloak.tokenParsed;
    }

    getIdToken() {
        return this.keycloak.idTokenParsed;
    }

    getRoles() {
        return this.storageService.getLocalItem(LOCAL_STORAGE_KEYS.USER_ROLES);
    }

    logout() {
        this.keycloak
            .logout({ redirectUri: window.location.origin })
            .then(() => {
                this.snack.successSnackbar('Logged Out SuccessFully');
                this.clearAllStorages();
            })
            .catch(() => {
                this.clearAllStorages();
            });
    }

    private clearAllStorages() {
        this.storageService.clearLocal();
        this.storageService.clearSession();
        localStorage.clear();
        sessionStorage.clear();
    }
}
